export default __webpack_public_path__ + "1ee55f57e1977ad8ce1f54c2f5290f81.svg";